import http from '../httpService';

export function getAllRevisionTypes() {
  return http.get(`/revision-types`);
}
export function updateRevisionTypes(payload) {
  return http.put('/revision-types', payload);
}

export function createRevisionTypes(payload) {
  return http.post('/revision-types', payload);
}

export function deleteRevisionTypes(id) {
  return http.delete(`/revision-types/${id}`);
}